function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).GooglePayButton = e(t.React);
}(this, function (t) {
  "use strict";

  function e(t) {
    return t && "object" == _typeof(t) && "default" in t ? t : {
      "default": t
    };
  }
  var n = e(t),
    _o = function o(t, e) {
      return (_o = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      })(t, e);
    };
  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
  
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
  
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */
  var _i = function i() {
    return (_i = Object.assign || function (t) {
      for (var e, n = 1, o = arguments.length; n < o; n++) for (var i in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      return t;
    }).apply(this, arguments);
  };
  function r(t, e, n, o) {
    return new (n || (n = Promise))(function (i, r) {
      function a(t) {
        try {
          l(o.next(t));
        } catch (t) {
          r(t);
        }
      }
      function s(t) {
        try {
          l(o["throw"](t));
        } catch (t) {
          r(t);
        }
      }
      function l(t) {
        var e;
        t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
          t(e);
        })).then(a, s);
      }
      l((o = o.apply(t, e || [])).next());
    });
  }
  function a(t, e) {
    var n,
      o,
      i,
      r,
      a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
    return r = {
      next: s(0),
      "throw": s(1),
      "return": s(2)
    }, "function" == typeof Symbol && (r[Symbol.iterator] = function () {
      return this;
    }), r;
    function s(r) {
      return function (s) {
        return function (r) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; a;) try {
            if (n = 1, o && (i = 2 & r[0] ? o["return"] : r[0] ? o["throw"] || ((i = o["return"]) && i.call(o), 0) : o.next) && !(i = i.call(o, r[1])).done) return i;
            switch (o = 0, i && (r = [2 & r[0], i.value]), r[0]) {
              case 0:
              case 1:
                i = r;
                break;
              case 4:
                return a.label++, {
                  value: r[1],
                  done: !1
                };
              case 5:
                a.label++, o = r[1], r = [0];
                continue;
              case 7:
                r = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                  a = 0;
                  continue;
                }
                if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                  a.label = r[1];
                  break;
                }
                if (6 === r[0] && a.label < i[1]) {
                  a.label = i[1], i = r;
                  break;
                }
                if (i && a.label < i[2]) {
                  a.label = i[2], a.ops.push(r);
                  break;
                }
                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            r = e.call(t, a);
          } catch (t) {
            r = [6, t], o = 0;
          } finally {
            n = i = 0;
          }
          if (5 & r[0]) throw r[1];
          return {
            value: r[0] ? r[1] : void 0,
            done: !0
          };
        }([r, s]);
      };
    }
  }
  var s = {};
  function l(t) {
    var e = s[t];
    if (e) return e;
    var n = new Promise(function (e, n) {
      var o = document.createElement("script");
      o.src = t, o.async = !0;
      var i = function i() {
          e();
        },
        r = function r() {
          o.removeEventListener("load", i), o.removeEventListener("error", r), delete s[t], o.remove(), n(new Error("Unable to load script " + t));
        };
      o.addEventListener("load", i), o.addEventListener("error", r), document.body.appendChild(o);
    });
    return s[t] = n, n;
  }
  var u = function () {
      function t(t) {
        var e = this;
        this.handleClick = function (t) {
          return r(e, void 0, void 0, function () {
            var e, n, o, i;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!(e = this.config)) throw new Error("google-pay-button: Missing configuration");
                  n = this.createLoadPaymentDataRequest(e), r.label = 1;
                case 1:
                  return r.trys.push([1, 3,, 4]), e.onClick && e.onClick(t), t.defaultPrevented ? [2] : [4, this.client.loadPaymentData(n)];
                case 2:
                  return o = r.sent(), e.onLoadPaymentData && e.onLoadPaymentData(o), [3, 4];
                case 3:
                  return "CANCELED" === (i = r.sent()).statusCode ? e.onCancel && e.onCancel(i) : e.onError ? e.onError(i) : console.error(i), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, this.options = t;
      }
      return t.prototype.getElement = function () {
        return this.element;
      }, t.prototype.isGooglePayLoaded = function () {
        var t, e;
        return "google" in (window || global) && !!(null === (e = null === (t = null === google || void 0 === google ? void 0 : google.payments) || void 0 === t ? void 0 : t.api) || void 0 === e ? void 0 : e.PaymentsClient);
      }, t.prototype.mount = function (t) {
        return r(this, void 0, void 0, function () {
          return a(this, function (e) {
            switch (e.label) {
              case 0:
                return this.isGooglePayLoaded() ? [3, 2] : [4, l("https://pay.google.com/gp/p/js/pay.js")];
              case 1:
                e.sent(), e.label = 2;
              case 2:
                return this.element = t, t && (this.appendStyles(), this.config && this.updateElement()), [2];
            }
          });
        });
      }, t.prototype.unmount = function () {
        this.element = void 0;
      }, t.prototype.configure = function (t) {
        var e = void 0;
        return this.config = t, this.oldInvalidationValues && !this.isClientInvalidated(t) || (e = this.updateElement()), this.oldInvalidationValues = this.getInvalidationValues(t), null != e ? e : Promise.resolve();
      }, t.prototype.createClientOptions = function (t) {
        var e = {
          environment: t.environment,
          merchantInfo: this.createMerchantInfo(t)
        };
        return (t.onPaymentDataChanged || t.onPaymentAuthorized) && (e.paymentDataCallbacks = {}, t.onPaymentDataChanged && (e.paymentDataCallbacks.onPaymentDataChanged = function (e) {
          return t.onPaymentDataChanged(e) || {};
        }), t.onPaymentAuthorized && (e.paymentDataCallbacks.onPaymentAuthorized = function (e) {
          return t.onPaymentAuthorized(e) || {};
        })), e;
      }, t.prototype.createIsReadyToPayRequest = function (t) {
        var e = t.paymentRequest;
        return {
          apiVersion: e.apiVersion,
          apiVersionMinor: e.apiVersionMinor,
          allowedPaymentMethods: e.allowedPaymentMethods,
          existingPaymentMethodRequired: t.existingPaymentMethodRequired
        };
      }, t.prototype.createLoadPaymentDataRequest = function (t) {
        return _i(_i({}, t.paymentRequest), {
          merchantInfo: this.createMerchantInfo(t)
        });
      }, t.prototype.createMerchantInfo = function (t) {
        var e = _i({}, t.paymentRequest.merchantInfo);
        return e.softwareInfo || (e.softwareInfo = {
          id: this.options.softwareInfoId,
          version: this.options.softwareInfoVersion
        }), e;
      }, t.prototype.isMounted = function () {
        return null != this.element && !1 !== this.element.isConnected;
      }, t.prototype.removeButton = function () {
        if (this.element instanceof ShadowRoot || this.element instanceof Element) for (var t = 0, e = Array.from(this.element.children); t < e.length; t++) {
          var n = e[t];
          "STYLE" !== n.tagName && n.remove();
        }
      }, t.prototype.updateElement = function () {
        return r(this, void 0, void 0, function () {
          var t, e, n, o, i, r, s, l;
          return a(this, function (a) {
            switch (a.label) {
              case 0:
                if (!this.isMounted()) return [2];
                if (t = this.getElement(), !this.config) throw new Error("google-pay-button: Missing configuration");
                this.removeButton(), this.client = new google.payments.api.PaymentsClient(this.createClientOptions(this.config)), e = {
                  buttonType: this.config.buttonType,
                  buttonColor: this.config.buttonColor,
                  buttonSizeMode: this.config.buttonSizeMode,
                  buttonLocale: this.config.buttonLocale,
                  onClick: this.handleClick,
                  allowedPaymentMethods: this.config.paymentRequest.allowedPaymentMethods
                }, (n = t.getRootNode()) instanceof ShadowRoot && (e.buttonRootNode = n), o = this.client.createButton(e), this.setClassName(t, [t.className, "not-ready"]), t.appendChild(o), i = !1, a.label = 1;
              case 1:
                return a.trys.push([1, 3,, 4]), [4, this.client.isReadyToPay(this.createIsReadyToPayRequest(this.config))];
              case 2:
                return r = a.sent(), i = r.result && !this.config.existingPaymentMethodRequired || r.result && r.paymentMethodPresent && this.config.existingPaymentMethodRequired || !1, [3, 4];
              case 3:
                return s = a.sent(), this.config.onError ? this.config.onError(s) : console.error(s), [3, 4];
              case 4:
                if (!this.isMounted()) return [2];
                if (i) {
                  try {
                    this.client.prefetchPaymentData(this.createLoadPaymentDataRequest(this.config));
                  } catch (t) {
                    console.log("Error with prefetch", t);
                  }
                  this.setClassName(t, (t.className || "").split(" ").filter(function (t) {
                    return t && "not-ready" !== t;
                  }));
                }
                return this.isReadyToPay === (null == r ? void 0 : r.result) && this.paymentMethodPresent === (null == r ? void 0 : r.paymentMethodPresent) || (this.isReadyToPay = !!(null == r ? void 0 : r.result), this.paymentMethodPresent = null == r ? void 0 : r.paymentMethodPresent, this.config.onReadyToPayChange && (l = {
                  isButtonVisible: i,
                  isReadyToPay: this.isReadyToPay
                }, this.paymentMethodPresent && (l.paymentMethodPresent = this.paymentMethodPresent), this.config.onReadyToPayChange(l))), [2];
            }
          });
        });
      }, t.prototype.setClassName = function (t, e) {
        var n = e.filter(function (t) {
          return t;
        }).join(" ");
        n ? t.className = n : t.removeAttribute("class");
      }, t.prototype.appendStyles = function () {
        var t, e, n;
        if ("undefined" != typeof document) {
          var o = null === (t = this.element) || void 0 === t ? void 0 : t.getRootNode(),
            i = "default-google-style-" + this.options.cssSelector.replace(/[^\w-]+/g, "") + "-" + (null === (e = this.config) || void 0 === e ? void 0 : e.buttonLocale);
          if (o && !(null === (n = o.getElementById) || void 0 === n ? void 0 : n.call(o, i))) {
            var r = document.createElement("style");
            r.id = i, r.type = "text/css", r.innerHTML = "\n          " + this.options.cssSelector + " {\n            display: inline-block;\n          }\n          " + this.options.cssSelector + ".not-ready {\n            width: 0;\n            height: 0;\n            overflow: hidden;\n          }\n        ", o instanceof Document && o.head ? o.head.appendChild(r) : o.appendChild(r);
          }
        }
      }, t.prototype.isClientInvalidated = function (t) {
        var e = this;
        return !this.oldInvalidationValues || this.getInvalidationValues(t).some(function (t, n) {
          return t !== e.oldInvalidationValues[n];
        });
      }, t.prototype.getInvalidationValues = function (t) {
        var e, n;
        return [t.environment, t.existingPaymentMethodRequired, !!t.onPaymentDataChanged, !!t.onPaymentAuthorized, t.buttonColor, t.buttonType, t.buttonLocale, t.buttonSizeMode, t.paymentRequest.merchantInfo.merchantId, t.paymentRequest.merchantInfo.merchantName, null === (e = t.paymentRequest.merchantInfo.softwareInfo) || void 0 === e ? void 0 : e.id, null === (n = t.paymentRequest.merchantInfo.softwareInfo) || void 0 === n ? void 0 : n.version, t.paymentRequest.allowedPaymentMethods];
      }, t;
    }(),
    c = "@google-pay/button-react",
    d = "google-pay-button-container";
  return function (t) {
    function e() {
      var e = null !== t && t.apply(this, arguments) || this;
      return e.manager = new u({
        cssSelector: "." + d,
        softwareInfoId: c,
        softwareInfoVersion: "2.6.0"
      }), e.elementRef = n["default"].createRef(), e;
    }
    return function (t, e) {
      function n() {
        this.constructor = t;
      }
      _o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    }(e, t), e.prototype.componentDidMount = function () {
      return r(this, void 0, void 0, function () {
        var t;
        return a(this, function (e) {
          switch (e.label) {
            case 0:
              return (t = this.elementRef.current) ? [4, this.manager.mount(t)] : [3, 2];
            case 1:
              e.sent(), this.manager.configure(this.props), e.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, e.prototype.componentWillUnmount = function () {
      this.manager.unmount();
    }, e.prototype.componentDidUpdate = function () {
      this.manager.configure(this.props);
    }, e.prototype.render = function () {
      return n["default"].createElement("div", {
        ref: this.elementRef,
        className: [d, this.props.className].filter(function (t) {
          return t;
        }).join(" "),
        style: this.props.style
      });
    }, e;
  }(n["default"].Component);
});